import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { MediaCellConfig } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'media-detail',
    templateUrl: './media-detail.template.html',
    styleUrls: ['./media-detail.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class MediaDetail {
    @Input() item: any;
    @Input() config: MediaCellConfig;
    @Input() snipe;
    private unfold: boolean;

    public settings: any = {
        showCopy: true,
        showTags: true,
        showTitle: true,
        showSub: true
    }


    ngOnChanges(changes) {
      
    }
    ngOnInit() {
        //apply default config
        Object.assign(this.settings, this.config);
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/media-cell/media-detail/media-detail.component.ts